import { Navigate } from 'react-router-dom';
import useUser from '../../../hooks/useUser';
import useToken from '../../../hooks/useToken';


export const ProtectedRoute = ({ children }: any) => {
  const { user }: any = useUser()
  const { token }: any = useToken()

  return (user && token) ? children : <Navigate to='/login' />
};
